import { create } from 'zustand';

interface UiState {
  sidebarOpen: boolean;

  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
}

// Below `lg` the same flag drives a full-screen drawer, not the desktop
// collapse, so starting it open covered the page on every phone page load.
const DESKTOP_BREAKPOINT = 1024;
const startsOpen = () => typeof window === 'undefined' || window.innerWidth >= DESKTOP_BREAKPOINT;

export const useUiStore = create<UiState>((set) => ({
  sidebarOpen: startsOpen(),

  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
  setSidebarOpen: (sidebarOpen) => set({ sidebarOpen }),
}));
